export default __webpack_public_path__ + "static/media/bowie67.427d1296.webp";